// service_ids that support payment info output
export const paymentSupportedServiceIds = [
  1336, // B_BIZ_SMBC
  2149, // B_BIZ_SMBC_CERT
  3772, // B_BIZ_SMBC_IC
  3911, // Mizuho
  3955, // B_BIZ_SMBC_API
  3967, // Mizuho
  4039, // MUFG
  4099, // MUFG
  4458 // GMO_AOZORA_NET
];
